import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import { GridFilterModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import DataGridKeywordOther from "src/components/data-grid/activations/data-grid-keyword-other";
import { useGetKeywordsQuery } from "src/context/api/activations/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";

export default function ActivationsKeywordOther(country: any) {
    const workspace = useCurrentWorkspace();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sortModel, setSortModel] = useState<any>([]);
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: []
    });
    const [localPatches, setLocalPatches] = useState({});

    const { data: keywordsExact, isFetching, refetch } = useGetKeywordsQuery(
        {
            client: workspace?.bqTable,
            page: page + 1,
            page_size: pageSize,
            workspace_id: workspace?.id,
            match_type: "OTHER",
            country: country?.country,
            sort: sortModel,
            filters: filterModel,
        },
        { skip: !workspace }
    );

    useEffect(() => {
        setPage(0);
        if (workspace) refetch();
    }, [sortModel, filterModel]);

    // Rendu
    return (
        <Box>
            {isFetching ? (
                <Skeleton variant="rectangular" height={400} width="100%" animation="wave" />
            ) : (
                <DataGridKeywordOther
                    data={keywordsExact?.data ?? []}
                    rowCount={keywordsExact?.total ?? 0}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={setPage}
                    onPageSizeChange={setPageSize}
                    sortModel={sortModel}
                    setSortModel={setSortModel}
                    filterModel={filterModel}
                    setFilterModel={setFilterModel}
                    localPatches={localPatches}
                    setLocalPatches={setLocalPatches}
                />
            )}
        </Box>
    );
}
